import {
  ITennisLiveScore
} from "@sky-it-livedata/livedata-sports-design-system";
import { loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";
import errors from "../../utils/errors";
import { LiveScoreData } from "./types";
import { intcmpMap } from "../../utils/intcmp";

const logger = loggerFactory();

const isValidObject = (obj: LiveScoreData) =>
  Boolean(obj?.data?.getLiveScoreWidget);

export const transformQuery = (obj: LiveScoreData): ITennisLiveScore => {
  console.log(obj);
  if (isValidObject(obj)) {
    try {
      const { liveTournaments, ctaUrls } = obj?.data?.getLiveScoreWidget;

      return {
        liveTournaments,
        ctaUrls: {
          atpCalendarUrl: { url: ctaUrls?.atpCalendarUrl || "", intcmp: intcmpMap.liveScoreAtpCalendar},
          atpRankingUrl: { url: ctaUrls?.atpRankingUrl || "", intcmp: intcmpMap.liveScoreAtpRanking},
          wtaCalendarUrl: { url: ctaUrls?.wtaCalendarUrl || "", intcmp: intcmpMap.liveScoreWtaCalendar},
          wtaRankingUrl: { url: ctaUrls?.wtaRankingUrl || "", intcmp: intcmpMap.liveScoreWtaRanking},
        },
        resultsIntcmp: intcmpMap.liveScoreAtpResults,
      } as ITennisLiveScore;
    } catch (error) {
      logger.error(
        "ERROR 6001: transform() error in Live Score transformer",
        obj
      );
      throw errors.fromCode(6001);
    }
  } else {
    logger.error("ERROR 6000", obj);
    throw errors.fromCode(6000);
  }
};